function report(state = {}, action) {
    switch(action.type){
        case 'CHANGE_REPORT_TYPE':
            return Object.assign({},state,{'reportType':action.payload});
        
        case 'FETCH_RECORDS_PAGE':
            return Object.assign({},state,{'page_records':action.payload});
            
        case 'SET_PAGINATION_CONFIG':
            return Object.assign({},state,{'paginationConfig':action.payload});
            
        case 'FETCH_REPORTS':
            return Object.assign({},state,{'reports':action.payload});

        case 'SET_BARCHART_LIST':
            return Object.assign({},state,{'barchartList':action.payload});

        case 'SET_TOTAL_SUM':
            return Object.assign({},state,{'total_sum':action.payload});

        case 'FETCH_ALL_RECORDS':
            return Object.assign({},state,{'all_records':action.payload});

        case 'SET_GROUP_BY':
            return Object.assign({},state,{'groupBy':action.payload});

        case 'SET_GROUPED_LOADING_STATE':
            return Object.assign({},state,{'loadingGroupedReport':action.payload});
        
        case 'SET_GROUPED_RECORDS':
            return Object.assign({},state,{'groupedReport':action.payload});

        case 'SET_PROJECT_FILTERS_NUMBER':
            return Object.assign({},state,{'project_filters_number':action.payload});

        case 'SET_USER_FILTERS_NUMBER':
            return Object.assign({},state,{'user_filters_number':action.payload});

        case 'SET_EXPORT_FILE':
            return Object.assign({},state,{'export_file': action.payload});

        default:
            return state
    }
}

export default report;